import { render, staticRenderFns } from "./modelConfigure.vue?vue&type=template&id=2b3e6b7b&scoped=true"
import script from "./modelConfigure.vue?vue&type=script&lang=js"
export * from "./modelConfigure.vue?vue&type=script&lang=js"
import style0 from "./modelConfigure.vue?vue&type=style&index=0&id=2b3e6b7b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3e6b7b",
  null
  
)

export default component.exports